import { faAngleDown as lightAngleDown } from "@jewlr/pro-light-svg-icons/faAngleDown"
import { faAngleUp as lightAngleUp } from "@jewlr/pro-light-svg-icons/faAngleUp"
import { Box, Flex, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
import { motion, AnimatePresence } from "framer-motion"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import withFilters from "areas/collection/hoc/with-filters"
import PriceRange from "areas/collection/price-range"

import FilterCategories from "./filter-categories"

const FilterLink = styled.div`
  margin-right: 25px;
  cursor: pointer;
  margin-right: 25px;
  text-transform: capitalize;
`
const Dropdown = styled(motion.div).attrs(() => ({
  animate: "enter",
  exit: "exit",
  initial: "exit",
  transition: {
    type: "linear",
  },
  variants: {
    exit: {
      transitionEnd: { boxShadow: "none", display: "none", overflow: "hidden" },
      height: 0,
    },
    enter: {
      boxShadow: "0 8px 10px 0 rgba(135,135,135,0.5)",
      display: "block",
      height: "auto",
    },
  },
}))`
  background-color: white;
  left: calc(-50vw + 50%);
  position: absolute;
  top: 35px;
  width: 100vw;
  z-index: 2;
`

/**
 * Filter menu for desktop
 * @param  {object} collectionFiltersWithPrice - all filter categories in collection
 */
const InternalFilterMenu = ({
  collectionFiltersWithPrice,
  openedFilter,
  toggleFilter,
}) => {
  if (!collectionFiltersWithPrice) return null

  const [openedCategory, setOpenedCategory] = useState({})
  const findFilter = () => {
    if (openedCategory && openedCategory.name) {
      return (
        collectionFiltersWithPrice.find(
          (filter) => filter.name === openedCategory.name
        ) || {}
      )
    } else {
      return {}
    }
  }

  useEffect(() => {
    setOpenedCategory(findFilter())
  }, [collectionFiltersWithPrice])

  return (
    <Flex alignItems="flex-end">
      <Box as="a" color="grey.70" fontSize={14} pr={6}>
        {" "}
        Filter By{" "}
      </Box>
      {collectionFiltersWithPrice.map((filter) => (
        <FilterLink
          data-cy={`collection-filter-menu-${filter.name
            .replace(/\s+/g, "-")
            .toLowerCase()}-desktop`}
          key={`catmenu${filter.name}`}
          onClick={(e) => {
            if (
              openedFilter &&
              openedCategory &&
              openedCategory.name === filter.name
            ) {
              toggleFilter(false)
            } else {
              toggleFilter(true)
              setOpenedCategory(filter)
            }
          }}
        >
          {filter.name != "Price" && (
            <Typography color="grey.70" fontSize={14}>
              {filter.name}{" "}
              <FontAwesomeIcon
                icon={
                  openedFilter &&
                  openedCategory &&
                  openedCategory.name === filter.name
                    ? lightAngleUp
                    : lightAngleDown
                }
                style={{ verticalAlign: "text-bottom" }}
              />
            </Typography>
          )}
        </FilterLink>
      ))}
      <AnimatePresence>
        {openedFilter &&
          openedCategory &&
          Object.keys(openedCategory).length > 0 && (
            <Dropdown key="menudrop" layout>
              {openedCategory.name === "Price" ? (
                <Box contain pb="40px" pt="30px">
                  <Typography fontSize="14px" mb="15px">
                    Price Range
                  </Typography>
                  <PriceRange />
                </Box>
              ) : (
                <FilterCategories
                  categories={[...openedCategory.categories]}
                  hasIcons={openedCategory.has_icons}
                  isUnique={openedCategory.unique}
                />
              )}
            </Dropdown>
          )}
      </AnimatePresence>
    </Flex>
  )
}

InternalFilterMenu.propTypes = {
  collectionFiltersWithPrice: PropTypes.array,
}

// Add 'Price' to filters
// const getFilters = (state, ownProps) => {
//   const filters = state.collection.filter_menu.all_collection_filters
//   if (!filters) return null
//   // return [{ name: "Price" }, ...filters]
//   return [...filters]
// }
const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}

const FilterMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(withFilters(InternalFilterMenu))

export default FilterMenu
